import _ from 'lodash';
import api from '../../utils/service';
import * as storage from '../../utils/storage';
import { loadingCycle } from './page';
import { reloadCurrentUserData } from './auth';
import { infoDismiss } from './info';

const CREATE_USER_PAYMENT_SUCCESS = 'redux/userPayment/CREATE_USER_PAYMENT_SUCCESS';
const CREATE_USER_PAYMENT_FAIL = 'redux/userPayment/CREATE_USER_PAYMENT_FAIL';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CREATE_USER_PAYMENT_SUCCESS:
      return {
        ...state,
        details: action.data,
        error: null,
      };
    case CREATE_USER_PAYMENT_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

export function createUserPayment(data) {
  return (dispatch) =>
    loadingCycle(api.post('/user-payments', data))
      .then(({ data }) => {
        // NOTE - Removes saved payment data after a payment is made
        storage.remove('paymentQuery');
        dispatch(infoDismiss());

        // NOTE - Success flow and auth confirmation to update accounts
        dispatch(createUserPaymentSuccess(data));
        return reloadCurrentUserData(dispatch);
      })
      .catch((error) => dispatch(createUserPaymentFail(error)));
}

export function createUserPaymentSuccess(data) {
  return {
    type: CREATE_USER_PAYMENT_SUCCESS,
    data,
  };
}

export function createUserPaymentFail(error) {
  return {
    type: CREATE_USER_PAYMENT_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}
